var _SHARE_TYPE_COMPONENT;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import EBPropTypes from 'js-utils/prop-types';
import _ from 'lodash';
import EmailShare from './EmailShare';
import FacebookShare from './FacebookShare';
import FacebookMessengerShare from './FacebookMessengerShare';
import TwitterShare from './TwitterShare';
import { FACEBOOK_PROP_TYPE_SHAPE, UTM_OPTION_PROPTYPE, SHARE_ON_EMAIL, SHARE_ON_FACEBOOK, SHARE_ON_FACEBOOK_MESSENGER, SHARE_ON_TWITTER, SHARE_TYPES, DEFAULT_UTM_OPTIONS, UTM_SHARE_TYPE_MAP } from './constants';
var SHARE_TYPE_COMPONENTS_MAP = (_SHARE_TYPE_COMPONENT = {}, _defineProperty(_SHARE_TYPE_COMPONENT, SHARE_ON_EMAIL, EmailShare), _defineProperty(_SHARE_TYPE_COMPONENT, SHARE_ON_FACEBOOK, FacebookShare), _defineProperty(_SHARE_TYPE_COMPONENT, SHARE_ON_FACEBOOK_MESSENGER, FacebookMessengerShare), _defineProperty(_SHARE_TYPE_COMPONENT, SHARE_ON_TWITTER, TwitterShare), _SHARE_TYPE_COMPONENT);

var _getShareComponent = function _getShareComponent(shareTypes, mergedUtmOptions, options, shareType) {
  var component = null; // if current share type is not contained on the wanted share types
  // we will skip it and not build it

  if (!shareTypes || shareTypes.includes(shareType)) {
    var boundOnClick;
    var ShareComponent = SHARE_TYPE_COMPONENTS_MAP[shareType];

    var onClick = options.onClick,
        shareOptions = _objectWithoutProperties(options, ["onClick"]);

    var typeSpecificUtmOptions = _objectSpread({}, mergedUtmOptions, UTM_SHARE_TYPE_MAP[shareType]);

    if (onClick) {
      boundOnClick = onClick.bind(null, shareType);
    }

    component = React.createElement(ShareComponent, _extends({
      key: shareType,
      onClick: boundOnClick,
      utmOptions: typeSpecificUtmOptions
    }, shareOptions));
  }

  return component;
};

var _generateShareComponents = function _generateShareComponents(shareTypes, mergedUtmOptions) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return _.chain(SHARE_TYPES) // transform the share type to a share component
  .map(function (shareType) {
    return _getShareComponent(shareTypes, mergedUtmOptions, options, shareType);
  }) // eliminate the null values
  .compact().value();
};

var ShareBox =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ShareBox, _React$Component);

  function ShareBox() {
    _classCallCheck(this, ShareBox);

    return _possibleConstructorReturn(this, _getPrototypeOf(ShareBox).apply(this, arguments));
  }

  _createClass(ShareBox, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          shareTypes = _this$props.shareTypes,
          utmOptions = _this$props.utmOptions,
          options = _objectWithoutProperties(_this$props, ["shareTypes", "utmOptions"]);

      var mergedUtmOptions = _objectSpread({}, DEFAULT_UTM_OPTIONS, utmOptions);

      var shareComponents = _generateShareComponents(shareTypes, mergedUtmOptions, options);

      return React.createElement("div", {
        "data-spec": "share-box-container"
      }, shareComponents);
    }
  }]);

  return ShareBox;
}(React.Component);

_defineProperty(ShareBox, "propTypes", {
  /**
   * Event's id
   */
  eventId: PropTypes.string.isRequired,

  /**
   * Event's name
   */
  eventName: PropTypes.string.isRequired,

  /**
   * Event's url
   */
  eventUrl: PropTypes.string.isRequired,

  /**
   * Facebook options
   */
  facebookOptions: FACEBOOK_PROP_TYPE_SHAPE.isRequired,

  /**
   * Server's url
   */
  serverUrl: PropTypes.string.isRequired,

  /**
   * Array containig all the shares type to show. If not provided, it will default to all
   */
  shareTypes: PropTypes.arrayOf(PropTypes.oneOf(SHARE_TYPES)),

  /**
   * Twitter handle
   */
  twitterHandle: PropTypes.string.isRequired,

  /**
   * Boolean prop to know if we're on a mobile device or not
   */
  isMobile: PropTypes.bool,

  /**
  * Function that onClick of one of the share options, passes
  * back an id of the clicked option
  */
  onClick: PropTypes.func,

  /**
  * Object that allows you to customize elements
  * of the UTM parameters passed via share
  */
  utmOptions: UTM_OPTION_PROPTYPE,

  /**
  * Configurable copy options
  * for prefilling the email
  */
  emailOptions: PropTypes.shape({
    //Defaults to the formatted url of the shared entity
    bodyCopy: EBPropTypes.translation,
    //Defaults to "You're invited to {eventName}"
    subjectCopy: EBPropTypes.translation
  })
});

export { ShareBox as default };